import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {User} from '../interfaces/users';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {DataService} from '../../services/data.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../private/private.component';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {DatePipe} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {RouterLink} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {TimestampPipe} from '../../shared/pipes/timestamp.pipe';



@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss'],
    standalone: true,
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        RouterLink,
        MatIconModule,
        MatTableModule,
        MatSortModule,
        TimestampPipe,
        DatePipe,
        MatPaginatorModule
    ]
})
export class UsersListComponent implements OnInit, AfterViewInit, OnDestroy {

    displayedColumns = ['displayName', 'email', 'firstName', 'lastName', 'googleUid', 'initials', 'roles', 'active', 'external', 'referent', 'jobClassification', 'actions'];
    dataSource = new MatTableDataSource<User>([]);

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    private destroy$ = new Subject<void>();

    constructor(
        private dataService: DataService,
        public dialog: MatDialog
    ) {
    }

    ngOnInit() {
        this.dataService.getUserList()
            .pipe(takeUntil(this.destroy$))
            .subscribe(users => {
                this.dataSource.data = users as User[];
            });

        this.dataSource.filterPredicate = (data: User, filter: string) => {
            const dataStr = [
                data.displayName,
                data.email,
                data.firstName,
                data.lastName,
                ...(data.type || [])
            ].join(' ').toLowerCase();
            return dataStr.includes(filter);
        };

        this.dataSource.filter = localStorage.getItem('userListFilter') || '';
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        const pageSize = localStorage.getItem('usersListPageSize');
        if (pageSize) {
            this.paginator.pageSize = +pageSize;
        }

        const sortId = localStorage.getItem('usersListSortId');
        const sortDirection = localStorage.getItem('usersListSortDirection');
        if (sortId && sortDirection) {
            this.sort.active = sortId;
            this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
        }

        this.paginator.page
            .pipe(takeUntil(this.destroy$))
            .subscribe(event => {
                localStorage.setItem('usersListPageSize', event.pageSize.toString());
            });

        this.sort.sortChange
            .pipe(takeUntil(this.destroy$))
            .subscribe(sortState => {
                localStorage.setItem('usersListSortId', sortState.active);
                localStorage.setItem('usersListSortDirection', sortState.direction);
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        const trimmedFilter = filterValue.trim().toLowerCase();
        this.dataSource.filter = trimmedFilter;
        localStorage.setItem('userListFilter', trimmedFilter);

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    public deleteUser(user: User) {
        const dialogMessage = {confirmMessage: `Are you sure you want to delete user: ${user.displayName}?`};
        const dialogData = {data: dialogMessage, height: '230px', width: '450px', disableClose: true};
        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogData);

        dialogRef.afterClosed().subscribe(choice => {
            if (choice && choice.confirm) {
                this.dataService.deleteUser(user)
                    .then(() => {
                        console.log('User deleted');
                    })
                    .catch((err) => {
                        console.error('Error while removing user', err.message);
                    });
            }
        });
    }
}
